import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=7af45530&scoped=true"
import script from "./activities.ts?vue&type=script&lang=ts&external"
export * from "./activities.ts?vue&type=script&lang=ts&external"
import style0 from "./activities.less?vue&type=style&index=0&id=7af45530&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af45530",
  null
  
)

export default component.exports